import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Quadtree from '../index/quadtree/Quadtree';
import ItemVisitor from '../index/ItemVisitor';
import LineSegment from '../geom/LineSegment';
import ArrayList from '../../../../java/util/ArrayList';
import Envelope from '../geom/Envelope';
import TaggedLineString from './TaggedLineString';
var LineSegmentIndex = /*#__PURE__*/function () {
  function LineSegmentIndex() {
    _classCallCheck(this, LineSegmentIndex);
    LineSegmentIndex.constructor_.apply(this, arguments);
  }
  _createClass(LineSegmentIndex, [{
    key: "remove",
    value: function remove(seg) {
      this._index.remove(new Envelope(seg.p0, seg.p1), seg);
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments[0] instanceof TaggedLineString) {
        var line = arguments[0];
        var segs = line.getSegments();
        for (var i = 0; i < segs.length; i++) {
          var seg = segs[i];
          this.add(seg);
        }
      } else if (arguments[0] instanceof LineSegment) {
        var _seg = arguments[0];
        this._index.insert(new Envelope(_seg.p0, _seg.p1), _seg);
      }
    }
  }, {
    key: "query",
    value: function query(querySeg) {
      var env = new Envelope(querySeg.p0, querySeg.p1);
      var visitor = new LineSegmentVisitor(querySeg);
      this._index.query(env, visitor);
      var itemsFound = visitor.getItems();
      return itemsFound;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._index = new Quadtree();
    }
  }]);
  return LineSegmentIndex;
}();
export { LineSegmentIndex as default };
var LineSegmentVisitor = /*#__PURE__*/function () {
  function LineSegmentVisitor() {
    _classCallCheck(this, LineSegmentVisitor);
    LineSegmentVisitor.constructor_.apply(this, arguments);
  }
  _createClass(LineSegmentVisitor, [{
    key: "visitItem",
    value: function visitItem(item) {
      var seg = item;
      if (Envelope.intersects(seg.p0, seg.p1, this._querySeg.p0, this._querySeg.p1)) this._items.add(item);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return this._items;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [ItemVisitor];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._querySeg = null;
      this._items = new ArrayList();
      var querySeg = arguments[0];
      this._querySeg = querySeg;
    }
  }]);
  return LineSegmentVisitor;
}();